// @ts-nocheck
/* eslint-disable */
import { getVisitorIpByStorage } from '@/api/sys/config';
import { checkInIframe } from '@/libs/util';

// 广告加载 360｜qq｜baidu
export const loadAds = async () => {
    if (checkInIframe()) {
        return; // iframe 嵌入模式下不加载埋点
    }

    /** ---------------- 360 统计 ---------------- */
    (function (b, a, e, h, f, c, g, s) {
        b[h] = b[h] || function () {
        (b[h].c = b[h].c || []).push(arguments);
        };
        b[h].s = !!c;
        g = a.getElementsByTagName(e)[0];
        s = a.createElement(e);
        s.src = "//s.union.360.cn/" + f + ".js";
        s.defer = true; // 兼容旧浏览器
        s.async = true; // async 异步
        g.parentNode.insertBefore(s, g);
    })(window, document, "script", "_qha", 544572, false);

    /** ---------------- 百度统计 ---------------- */
    window._agl = window._agl || [];
    window._agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD']);

    const baiduScript = document.createElement('script');
    baiduScript.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
    baiduScript.async = true;
    document.body.appendChild(baiduScript);

    try {
        const res = await getVisitorIpByStorage(true, false);
        const isChinaIP = res.data.data?.ip_data?.country === 'cn';

        if (!isChinaIP) {
            /** ---------------- TikTok Analytics ---------------- */
            (function (w, d, t) {
                w.TiktokAnalyticsObject = t;
                var ttq = w[t] = w[t] || [];
                ttq.methods = [
                "page","track","identify","instances","debug","on","off","once",
                "ready","alias","group","enableCookie","disableCookie",
                "holdConsent","revokeConsent","grantConsent"
                ];
                ttq.setAndDefer = function (t, e) {
                t[e] = function () {
                    t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
                }
                };
                for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
                ttq.instance = function (t) {
                for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
                    ttq.setAndDefer(e, ttq.methods[n]);
                return e;
                };
                ttq._i = ttq._i || {};
                ttq._t = ttq._t || {};
                ttq._o = ttq._o || {};
                ttq.load = function (e, n) {
                var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
                n = n || {};
                ttq._i[e] = [];
                ttq._i[e]._u = r;
                ttq._t[e] = +new Date;
                ttq._o[e] = n;
                var s = d.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = r + "?sdkid=" + e + "&lib=" + t;
                var x = d.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);
                };

                // 初始化 + 上报
                ttq.load('CT4JMA3C77UBGVBCIHCG');
                ttq.page();
            })(window, document, 'ttq');
        }
    } catch (e) {
        console.error(e);
    }
};

/* eslint-enable */
